import styled from "styled-components";
import ReckewegBackground from '../../assets/Lines/reckeweg-background.png'

export const ProductBannerContainer = styled.div`
height: 15vh;
    background-image: url(${ReckewegBackground});
   background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;

`